import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp, doc, updateDoc } from 'firebase/firestore';
import { ref, uploadString, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase';
import CameraScanner from './CameraScanner';
import './CreatePrescriptionForm.css';
import { toast } from 'react-toastify';
import EmptyPres from './EmptyPrescription';

function CreatePrescriptionForm({ appointment, onBack }) {
  const [medicines, setMedicines] = useState([{ name: '', potency: '', manufacturer: '' }]);
  const [image, setImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleChange = (index, e) => {
    const updated = [...medicines];
    updated[index][e.target.name] = e.target.value;
    setMedicines(updated);
  };

  const addMedicine = () => {
    setMedicines([...medicines, { name: '', potency: '', manufacturer: '' }]);
  };

  const handleImageCapture = (capturedImage) => {
    setImage(capturedImage);
    console.log('Captured image:', capturedImage);
  };

  const handleSubmit = async (e) => {
  if (e) e.preventDefault();
  if (submitting) return;

  // 🛡️ Check if prescription already exists
  if (appointment.prescriptionId) {
    toast.error("Prescription already exists for this appointment.");
    return;
  }

  // 🛡️ Validate form: Must have at least one medicine OR image
  const hasValidMedicines = medicines.some(med => med.name.trim() !== '');
  if (!hasValidMedicines && !image) {
    setConfirmOpen(true);
    return;
  }

  setSubmitting(true);

  try {
    // 1. Create initial prescription doc
    const docRef = await addDoc(collection(db, 'prescriptions'), {
      appointmentId: appointment.id,
      patientId: appointment.patientId,
      doctorId: appointment.doctorId,
      medicines: medicines.filter(med => med.name.trim() !== ''),
      createdAt: serverTimestamp()
    });

    // 2. Upload slip if image exists
    if (image) {
      const imageRef = ref(storage, `prescription_slips/${docRef.id}.jpg`);
      await uploadString(imageRef, image, 'data_url');
      const slipUrl = await getDownloadURL(imageRef);

      // 3. Update prescription doc with slip URL
      await updateDoc(doc(db, 'prescriptions', docRef.id), { slipUrl });
    }

    // 4. Update appointment doc with prescriptionId
    await updateDoc(doc(db, 'appointments', appointment.id), {
      prescriptionId: docRef.id
    });

    toast.success("Prescription saved successfully!");
    onBack();
  } catch (error) {
    console.error("Error saving prescription:", error);
    toast.error("Failed to save prescription.");
  } finally {
    setSubmitting(false);
  }
};


  return (
    <div className="prescription-form-container">
      <div className="prescription-header">
      <h3>Create Prescription</h3>
      <h4>Patient Name: {appointment.patientName}</h4>
      </div>

      <form onSubmit={handleSubmit}>
        {medicines.map((med, idx) => (
          <div key={idx} className="medicine-row">
            <input name="name" placeholder="Medicine" value={med.name} onChange={(e) => handleChange(idx, e)} />
            <input name="potency" placeholder="Potency" value={med.potency} onChange={(e) => handleChange(idx, e)} />
            <input name="manufacturer" placeholder="Manufacturer" value={med.manufacturer} onChange={(e) => handleChange(idx, e)} />
          </div>
          
        ))}
        <button className="add-medicine-btn" type="button" onClick={addMedicine} disabled={submitting}>Add Another Medicine</button>

        <div className="upload-section">
        {!image ? (
          <CameraScanner onCapture={handleImageCapture} />
        ) : (
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <h3>Preview</h3>
            <div className='upload-preview-container'>
              <img className="upload-preview" src={image} alt="Scanned Prescription" />
              <div>
                <button className="camera-button" onClick={() => setImage(null)} disabled={submitting}>Rescan</button>
              </div>
            </div>
          </div>
        )}
      </div>

        <div className="action-buttons">
          <button className="submit-btn" type="submit" onClick={handleSubmit} disabled={submitting}>
          {submitting ? 'Saving...' : 'Create Prescription'}
          </button>
          <button className="cancel-btn" type="button" onClick={onBack} disabled={submitting}>Cancel</button>
        </div>
      </form>
      
        <EmptyPres
        open={confirmOpen}
        title="Empty Prescription"
        onCancel={() => setConfirmOpen(false)}
      />

    </div>
  );
}

export default CreatePrescriptionForm;


/*import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import CameraScanner from './CameraScanner';
import { ref, uploadString, getDownloadURL, uploadBytes } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';
import { storage } from '../firebase';
import './CreatePrescriptionForm.css';

function CreatePrescriptionForm({ appointment, onBack }) {
  const [medicines, setMedicines] = useState([
    { name: '', potency: '', manufacturer: '' },
  ]);
  const [image, setImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);


  if (submitting) return; // Prevent double click
    setSubmitting(true);




  const handleChange = (index, e) => {
    const updated = [...medicines];
    updated[index][e.target.name] = e.target.value;
    setMedicines(updated);
  };

  const addMedicine = () => {
    setMedicines([...medicines, { name: '', potency: '', manufacturer: '' }]);
  };

  const handleImageCapture = (capturedImage) => {
    setImage(capturedImage); // You can preview this or move to step 2
    console.log('Captured image:', capturedImage);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // 1. Create initial doc (without slipUrl)
    const docRef = await addDoc(collection(db, 'prescriptions'), {
      appointmentId: appointment.id,
      patientId: appointment.patientId,
      doctorId: appointment.doctorId,
      medicines: medicines.filter(med => med.name), // optional
      createdAt: serverTimestamp()
    });

    // 2. If there's an image, upload it and update the same doc
    if (image) {
      const imageRef = ref(storage, `prescription_slips/${docRef.id}.jpg`);
      await uploadString(imageRef, image, 'data_url');
      const slipUrl = await getDownloadURL(imageRef);

      // 3. Update that same doc with slipUrl
      await updateDoc(doc(db, 'prescriptions', docRef.id), {
        slipUrl: slipUrl
      });

      // 4. Update appointment doc with prescriptionId
      await updateDoc(doc(db, 'appointments', appointment.id), {
        prescriptionId: docRef.id
      });

    }

    alert('Prescription saved successfully!');
    onBack();
  } catch (error) {
    console.error('Error saving prescription:', error);
    alert('Failed to save prescription');
  }
};


  return (
    <div className="prescription-form-container">
  <div className="prescription-header">
    <h3>Create Prescription</h3>
    <h4>Patient Name: {appointment.patientName}</h4>
  </div>

  <form onSubmit={handleSubmit}>
    {medicines.map((med, idx) => (
      <div key={idx} className="medicine-row">
        <input
          name="name"
          placeholder="Medicine"
          value={med.name}
          onChange={(e) => handleChange(idx, e)}
        />
        <input
          name="potency"
          placeholder="Potency"
          value={med.potency}
          onChange={(e) => handleChange(idx, e)}
        />
        <input
          name="manufacturer"
          placeholder="Manufacturer"
          value={med.manufacturer}
          onChange={(e) => handleChange(idx, e)}
        />
      </div>
    ))}

    <button
      type="button"
      onClick={addMedicine}
      className="add-medicine-btn"
    >
      Add Another Medicine
    </button>


    <div className="upload-section">
    {!image ? (
      <CameraScanner onCapture={handleImageCapture} />
    ) : (
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <h3>Preview</h3>
        <div className="upload-preview-container">
          <img
            src={image}
            alt="Scanned Prescription"
            className="upload-preview"
          />
          <div>
            <button className='camera-button' onClick={() => setImage(null)}>Rescan</button>
            <button className='camera-button' onClick={() => alert("Slip confirmed. Now fill medicines and submit.")}>OK</button>
          </div>
        </div>
      </div>
    )}
  </div>

    <div className="action-buttons">
      <button type="submit" className="submit-btn">Create Prescription</button>
      <button type="button" onClick={onBack} className="cancel-btn">Cancel</button>
    </div>
  </form>
</div>

  );
}

export default CreatePrescriptionForm;*/


//v2 handle submit working stable

/*

const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (submitting) return;

    setSubmitting(true);

    try {
      // 1. Create initial doc
      const docRef = await addDoc(collection(db, 'prescriptions'), {
        appointmentId: appointment.id,
        patientId: appointment.patientId,
        doctorId: appointment.doctorId,
        medicines: medicines.filter(med => med.name),
        createdAt: serverTimestamp()
      });

      // 2. Upload image if exists
      if (image) {
        const imageRef = ref(storage, `prescription_slips/${docRef.id}.jpg`);
        await uploadString(imageRef, image, 'data_url');
        const slipUrl = await getDownloadURL(imageRef);

        // 3. Update prescription with slip URL
        await updateDoc(doc(db, 'prescriptions', docRef.id), {
          slipUrl: slipUrl
        });
      }

      // 4. Update appointment with prescriptionId
      await updateDoc(doc(db, 'appointments', appointment.id), {
        prescriptionId: docRef.id
      });

      alert('Prescription saved successfully!');
      onBack();
    } catch (error) {
      console.error('Error saving prescription:', error);
      alert('Failed to save prescription');
    } finally {
      setSubmitting(false);
    }
  };

*/